import { Battery1 as r } from "./battery-1.js";
import { Battery2 as o } from "./battery-2.js";
import { Battery3 as m } from "./battery-3.js";
import { BatteryEmpty as i } from "./battery-empty.js";
import { Bin as t } from "./bin.js";
import { Blocked as p } from "./blocked.js";
import { Breadcrumb as f } from "./breadcrumb.js";
import { Bucket as l } from "./bucket.js";
import { Calendar7 as e } from "./calendar-7.js";
import { Chain1 as a } from "./chain-1.js";
import { Chain2 as n } from "./chain-2.js";
import { CheckmarkCircle as c } from "./checkmark-circle.js";
import { CheckmarkCircleFill as s } from "./checkmark-circle-fill.js";
import { CheckmarkCircleSmall as C } from "./checkmark-circle-small.js";
import { CheckmarkCircleSmallFill as u } from "./checkmark-circle-small-filled.js";
import { CheckmarkSmall as S } from "./checkmark-small.js";
import { CheckmarkSquare as d } from "./checkmark-square.js";
import { CheckmarkSquareFilled as h } from "./checkmark-square-filled.js";
import { Clock as k } from "./clock.js";
import { Code1 as F } from "./code-1.js";
import { Code2 as M } from "./code-2.js";
import { Code3 as P } from "./code-3.js";
import { Collection as g } from "./collection.js";
import { Collections as y } from "./collections.js";
import { Copy as B } from "./copy.js";
import { Cross as T } from "./cross.js";
import { CrossCircle as q } from "./cross-circle.js";
import { CrossCircleFill as H } from "./cross-circle-fill.js";
import { CrossSmall as W } from "./cross-small.js";
import { Edit as b } from "./edit.js";
import { Edit2 as I } from "./edit-2.js";
import { Edited as E } from "./edited.js";
import { Filter as L } from "./filter.js";
import { Fingerprint as O } from "./fp.js";
import { Grab as w } from "./grab.js";
import { Heart as D } from "./heart.js";
import { HeartFill as Z } from "./heart-fill.js";
import { Hide as v } from "./hide.js";
import { Hourglass as x } from "./hourglass.js";
import { Info as z } from "./info.js";
import { InfoFilled as G } from "./info-filled.js";
import { LetterI as N } from "./letter-i.js";
import { LineHeight as U } from "./line-height.js";
import { Location as V } from "./location.js";
import { Mail as j } from "./mail.js";
import { Menu as A } from "./menu.js";
import { Message as J } from "./message.js";
import { MinusCircle as K } from "./minus-circle.js";
import { MinusCircleFilled as Q } from "./minus-circle-filled.js";
import { MinusMultiple as R } from "./minus-multiple.js";
import { MinusSmall as X } from "./minus-small.js";
import { MinusSquare as Y } from "./minus-square.js";
import { MinusSquareFilled as _ } from "./minus-square-filled.js";
import { Notification as $ } from "./notification.js";
import { OptionsHorizontal as rr } from "./options-horizontal.js";
import { OptionsVertical as or } from "./options-verical.js";
import { Person as mr } from "./person.js";
import { PersonCircle as ir } from "./person-circle.js";
import { Pin as tr } from "./pin.js";
import { Play as pr } from "./play.js";
import { PlayCircle as fr } from "./play-circle.js";
import { PlayCircleFill as lr } from "./play-circle-fill.js";
import { Plus as er } from "./plus.js";
import { PlusMedium as ar } from "./plus-medium.js";
import { PlusMultiple as nr } from "./plus-multiple.js";
import { PlusSmall as cr } from "./plus-small.js";
import { PlusSquare as sr } from "./plus-square.js";
import { PlusSquareFilled as Cr } from "./plus-square-filled.js";
import { Save as ur } from "./save.js";
import { Search as Sr } from "./search.js";
import { SearchList as dr } from "./search-list.js";
import { SearchSmall as hr } from "./search-small.js";
import { Settings as kr } from "./settings.js";
import { Share2 as Fr } from "./share-2.js";
import { Show as Mr } from "./show.js";
import { Sleep as Pr } from "./sleep.js";
import { Sliders as gr } from "./sliders.js";
import { Sliders2 as yr } from "./sliders-2.js";
import { Sound as Br } from "./sound.js";
import { Stack as Tr } from "./stack.js";
import { Star as qr } from "./star.js";
import { StarFill as Hr } from "./star-fill.js";
import { Stop as Wr } from "./stop.js";
import { Table as br } from "./table.js";
import { Tag as Ir } from "./tag.js";
import { ThumbDown as Er } from "./thumb-down.js";
import { ThumbUp as Lr } from "./thumb-up.js";
import { Timer as Or } from "./timer.js";
import { Tooltip as wr } from "./tooltip.js";
import { Touch as Dr } from "./touch.js";
import { Warning as Zr } from "./warning.js";
import { WarningCircle as vr } from "./warning-circle.js";
import { WarningCircleFill as xr } from "./warning-circle-fill.js";
import { WarningDiamondFilled as zr } from "./warning-diamond-filled.js";
import { WarningFilled as Gr } from "./warning-filled.js";
import { Wireless as Nr } from "./wireless.js";
import { ZoomIn as Ur } from "./zoom-in.js";
import { ZoomOut as Vr } from "./zoom-out.js";
const Dm = {
  Calendar7: e,
  CheckmarkSmall: S,
  CheckmarkCircleFill: s,
  Clock: k,
  Cross: T,
  CrossCircleFill: H,
  Location: V,
  Menu: A,
  SearchList: dr,
  Search: Sr,
  Sliders2: yr,
  Star: qr,
  StarFill: Hr,
  Info: z,
  InfoFilled: G,
  Plus: er,
  PlayCircle: fr,
  ThumbUp: Lr,
  ThumbDown: Er,
  Tooltip: wr,
  Collection: g,
  Collections: y,
  Warning: Zr,
  WarningFilled: Gr,
  WarningDiamondFilled: zr,
  PlusSmall: cr,
  PlusMedium: ar,
  MinusSmall: X,
  MinusCircle: K,
  MinusCircleFilled: Q,
  PlusSquare: sr,
  PlusSquareFilled: Cr,
  MinusSquare: Y,
  MinusSquareFilled: _,
  PlusMultiple: nr,
  MinusMultiple: R,
  CheckmarkCircleSmall: C,
  CheckmarkCircleSmallFill: u,
  WarningCircleFill: xr,
  WarningCircle: vr,
  Blocked: p,
  PlayCircleFill: lr,
  SearchSmall: hr,
  ZoomIn: Ur,
  ZoomOut: Vr,
  Sliders: gr,
  Show: Mr,
  Hide: v,
  Filter: L,
  Pin: tr,
  Sleep: Pr,
  Timer: Or,
  Hourglass: x,
  Settings: kr,
  Edit: b,
  Edit2: I,
  Edited: E,
  Mail: j,
  Message: J,
  Bucket: l,
  Copy: B,
  Tag: Ir,
  Grab: w,
  Person: mr,
  PersonCircle: ir,
  OptionsVertical: or,
  OptionsHorizontal: rr,
  Code1: F,
  Code2: M,
  Code3: P,
  Heart: D,
  HeartFill: Z,
  Save: ur,
  Chain1: a,
  Chain2: n,
  Table: br,
  Stop: Wr,
  Play: pr,
  LetterI: N,
  Share2: Fr,
  Breadcrumb: f,
  Fingerprint: O,
  Battery3: m,
  Battery2: o,
  Battery1: r,
  BatteryEmpty: i,
  Sound: Br,
  Wireless: Nr,
  Touch: Dr,
  LineHeight: U,
  Stack: Tr,
  Bin: t,
  Notification: $,
  CrossCircle: q,
  CheckmarkCircle: c,
  CheckmarkSquare: d,
  CheckmarkSquareFilled: h,
  CrossSmall: W
};
export {
  Dm as Interface
};
